import React from 'react'
import format from '../../helpers/format'
import { Link, LinkIcon } from '../'

const EsgConfig = {
  esgNamesLabels: [
    {
      label: 'Fossil fuels',
      value: 'fossils',
    },
    {
      label: 'Fossil finance score',
      value: 'finance'
    },
    {
      label: 'Fossil insurance score',
      value: 'insurance'
    },
    {
      label: 'Clean200',
      value: 'clean'
    }
  ],
  esgOptions: {
    fossils: {
      id: 'fossils',
      icon: 'icons_step4',
      fieldLabel: 'c2f5coogutweight',
      benchLabel: 'c2f5coogutweight',
      valueLabel: 'Fossil fuel %',
      direction: 'ascending',
      page: 'fossil-fuel-investments',
      label: 'in fossil fuels',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in fossil fuel companies {(url)?(<Link xstrong={true} to={url}><small>More <LinkIcon/></small></Link>):null}
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in fossil fuel companies {(url)?(<Link xstrong={true} to={url}><small>More <LinkIcon/></small></Link>):null}
          </span>
        )
      }
    },
    finance: {
      id: 'finance',
      icon: 'icons_step3',
      fieldLabel: 'fossil_bank_score',
      benchLabel: 'fossil_bank_score',
      valueLabel: 'Fossil finance score',
      direction: 'ascending',
      page: 'finance',
      label: 'fossil finance risk score',
      units: 'points',
      unitsExpanded: ' points',
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'Higher' : 'Lower',
      format : (val) => format.number(val, true, true),
      formatExpanded: (val, higherLower, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same</strong> fossil finance risk score {(url)?(<Link xstrong={true} to={url}><small>More <LinkIcon/></small></Link>):null}
            </span>
          )
        }
        return (
          <span>
            a fossil finance risk score <strong styleName={postiveNegative}>{higherLower} by {format.number(val)} points</strong> {(url)?(<Link xstrong={true} to={url}><small>More <LinkIcon/></small></Link>):null}
          </span>
        )
      }
    },
    insurance: {
      id: 'insurance',
      icon: 'icons_step3',
      fieldLabel: 'fossil_insure_score',
      benchLabel: 'fossil_insure_score',
      valueLabel: 'Fossil insurance score',
      direction: 'ascending',
      page: 'insurance',
      label: 'fossil insurance risk score',
      units: 'points',
      unitsExpanded: ' points',
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'Higher' : 'Lower',
      format : (val) => format.number(val, true, true),
      formatExpanded: (val, higherLower, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same</strong> fossil insurance risk score {(url)?(<Link xstrong={true} to={url}><small>More <LinkIcon/></small></Link>):null}
            </span>
          )
        }
        return (
          <span>
            a fossil insurance risk score <strong styleName={postiveNegative}>{higherLower} by {format.number(val)} points</strong> {(url)?(<Link xstrong={true} to={url}><small>More <LinkIcon/></small></Link>):null}
          </span>
        )
      }
    },
    clean: {
      id: 'clean',
      icon: 'icons_step2',
      fieldLabel: 'cl_weight',
      benchLabel: 'cl_weight',
      valueLabel: 'Clean200 %',
      direction: 'descending',
      page: 'clean200-investments',
      label: 'in Clean200',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff > 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-good' : 'lower-bad',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in Clean200 companies {(url)?(<Link xstrong={true} to={url}><small>More <LinkIcon/></small></Link>):null}
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in Clean200 companies {(url)?(<Link xstrong={true} to={url}><small>More <LinkIcon/></small></Link>):null}
          </span>
        )
      }
    }
  }
}

export default EsgConfig